import { GetStatementsApiParameter } from "@gerrieDev/Services/StatementService";
import { CustomActions } from "@gerrieDev/Store/Reducers";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{
    getStatementsParameter: GetStatementsApiParameter,
    onUnauthenticated?: () => void,
    onBeginDownload?: () => void,
    onSuccess?: () => void,
    onError?: () => void,
}, DispatchProp<CustomActions>>;

export const DownloadStatement: HandlerType = props => {
    if (!props.getState().context.session?.isAuthenticated) {
        props.parameter.onUnauthenticated?.();
        return false;
    }

    props.parameter.onBeginDownload?.();

    const apiUrl = `${window.origin}/api/v1/GerrieStatement/export-view-to-excel`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(props.parameter.getStatementsParameter)
    };

    fetch(apiUrl, requestOptions).then((response: Response) => {
        if (response.status === 200) {
            response.blob().then(blob => {
                if (blob.size > 25) {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    const filename =  response.headers.get('Content-Disposition')?.split('filename=')[1] ?? "statement.xlsx";
                    link.setAttribute("download", filename);
                    link.click();
                } else {
                    props.parameter.onError?.();
                }
            });
        } else {
            props.parameter.onError?.();
        }
    });

    props.parameter.onSuccess?.();
};

export const chain = [DownloadStatement];

const downloadStatement = createHandlerChainRunner(chain, "DownloadStatement");
export default downloadStatement;
